module.exports = __webpack_public_path__ + "static/media/settings.8aa61e32.svg";